module.exports = {"backend":{"clientId":null,"clientSecret":"XDUX7mMQ97UcBZMc3F5vEsuSYHTqwn9kW87vtMpNHCBAJqUJrHwUPNuLJXn2J94Wmty2bvRdVeedrkcNhgWfwSwYunCND7sbg4uF5XKNKg3jQNDS3fWMYNYxue6DE8B2","url":"./a/api","scope":"manage_all"},"googleMapsApiKey":"AIzaSyDoCozij59ze0LDin-uG7urkTzl0xZepA4","companyId":"61f5b0b6-e499-4318-89e6-3cbd3f171f07"}


//////////////////
// WEBPACK FOOTER
// ./src/App/Config/config.prod.json
// module id = 745
// module chunks = 0